export default __webpack_public_path__ + "static/media/campaign_welcome_icon.c0aa0f11.png";